import { abbreviateNumber } from './abbreviateNumber';
import { DEFAULT_LOCALE } from './constants';

export function formatCount(count: number, long?: boolean) {
  return long ? count.toLocaleString(DEFAULT_LOCALE) : abbreviateNumber(count, { maximumFractionDigits: 1 });
}
